import resume from '../assets/pdf/Resume2.pdf'
import img from '../IMG_20211121_114134.jpg'

export const headerData = {
    name: 'Samuel Yadav',
    title: "Full Stack Web Developer",
    desciption:" An aspire software engineer who is working on websites and Creatively solving Data Structure and Algorithms Problem.\n Currently learning MERN Stack | Full Stack Development\n I’m looking to collaborate on MERN Stack Projects",
    image: img,
    resumePdf: resume
}
